import { useQuery } from "react-query";
import { internalApi } from "@/react/helpers/urlHelpers";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";

export const useStudentProgress = (spaceMemberId: number, courseId: number) => {
  const { data: student, isLoading } = useQuery(
    ["studentProgress", courseId, spaceMemberId],
    () =>
      reactQueryGet(
        internalApi.courses.students.show({ courseId, spaceMemberId }),
      ),
    {
      enabled: Boolean(spaceMemberId && courseId),
    },
  );

  const curriculum = student?.curriculum || [];

  return {
    curriculum,
    isLoading,
  };
};
